<template>
  <div v-show="imgShow"
       class="loading_box left">
    <div class="loading_mask"></div>
    <div class="loading_toast"
         @mousewheel.prevent="rollImg">
      <img ref="imgDiv"
           alt=""
           class="img"
           :src="imgUrl"
           @mousedown="move"
           @touchstart.stop="move($event,'touchmove')" />
    </div>
    <div @click="onImgMiss"
         class="loading_close iconfont icon-guanbi"></div>
  </div>
</template>
<script>
export default {
  props: {
    imgShow: {
      type: Boolean,
      default: false
    },
    imgUrl: {
      type: String,
      default: function () {
        return '';
      }
    },
    setScreenWidth: {
      type: Number,
      default: false
    }
  },
  data () {
    return {
      show: false,
      picUrl: '',
      picSetScreenWidth: 0,
      multiples: 1,
    };
  },
  created () {
    if (this.imgShow) {
      this.show = this.imgShow;
    }
    if (this.imgUrl) {
      this.picUrl = this.imgUrl;
    }
    if (this.setScreenWidth) {
      this.picSetScreenWidth = this.setScreenWidth;
    }
  },
  watch: {
    imgShow (val) {
      this.show = val;
    },
    imgUrl (val) {
      this.picUrl = val;
    },
    setScreenWidth (val) {
      this.picSetScreenWidth = val;
    }
  },
  methods: {
    onImgMiss () {
      this.$emit('closeimg')
    },



    // 拖动图片
    move (e, a) {
      e.preventDefault();
      // 获取元素
      var left = document.querySelector(".left");
      var img = document.querySelector(".img");



      // 添加鼠标移动事件
      if (a == 'touchmove') {
        var x = e.touches[0].clientX - e.target.offsetLeft - img.clientWidth / 2
        var y = e.touches[0].clientY - e.target.offsetTop - img.clientHeight / 2
        left.addEventListener("touchmove", move);
        img.addEventListener("touchend", function () {
          left.removeEventListener("touchmove", move);
        });
        left.addEventListener("touchend", function () {
          left.removeEventListener("touchmove", move);
        });
        function move (e) {
          img.style.left = e.touches[0].clientX - x + "px"
          img.style.top = e.touches[0].clientY - y + "px"
        }
      } else {
        var x = e.pageX - img.offsetLeft - img.clientWidth / 2
        var y = e.pageY - img.offsetTop - img.clientHeight / 2
        left.addEventListener("mousemove", movePc);
        // 添加鼠标抬起事件，鼠标抬起，将事件移除
        img.addEventListener("mouseup", function () {
          left.removeEventListener("mousemove", movePc);
        });
        // 鼠标离开父级元素，把事件移除
        left.addEventListener("mouseout", function () {
          left.removeEventListener("mousemove", movePc);
        });
        function movePc (e) {
          img.style.left = e.pageX - x + "px"
          img.style.top = e.pageY - y + "px"
        }
      }
    },

    // 缩放图片
    rollImg () {
      /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
      var zoom = parseInt(this.$refs.imgDiv.style.zoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */

      zoom += event.wheelDelta / 12;
      /* 最小范围 和 最大范围 的图片缩放尺度 */

      if (zoom >= 80 && zoom < 500) {
        this.$refs.imgDiv.style.zoom = zoom + "%";
      }
      return false;
    }
  }
};
</script>
 
<style lang="scss" scoped>
// @import "@/assets/style/mixin";
.loading_close {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2;
  font-size: 30px;
  padding: 3px;
  color: #fff;
  background: #333;
  cursor: pointer;
}
.loading_box .loading_mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
.loading_box .loading_toast {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translateX(-50%) translateY(-50%);
  // border-radius: 5px;
  // background: rgba(0, 0, 0, 0.8);
  text-align: center;
  padding: 25px 0;
  box-sizing: border-box;
  // font-size: 18px;
  z-index: 1;
  // img {
  //   width: 100%;
  //   height: 100%;
  //   object-fit: contain;
  // }
}

.left {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  float: left;
  overflow: hidden;
}
.img {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -500px;
  margin-top: -334px;
  max-width: 1000px;
  max-height: 668px;
  cursor: move;
}

@media (max-width: 768px) {
  .img {
    margin-left: -250px;
    margin-top: -334px;
    max-width: 500px;
    max-height: 668px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PicShow.vue